import axios from "axios";
import CONFIG from "../../../constanta/config";
import { useState } from "react";
import parse from "html-react-parser";
import LogoApp from "../../../components/logoapp";

const CardIntro = (props) => {
  const { user, game, activity } = props;
  const [loading, setLoading] = useState();

  const postScore = async () => {

    if (props.score !== "") {
      props.handleBegin();
      return;
    }

    if (loading) {
      return;
    }

    setLoading(true);

    const payload = {
      id_activity: activity?.id,
      score: -1,
      game_data: JSON.stringify({ status: "playing" }),
    };

    var form_data = new FormData();

    for (var key in payload) {
      form_data.append(key, payload[key]);
    }

    axios
      .post(CONFIG.URL + "/score?rnd=" + Date.now(), form_data, {
        headers: {
          token: user?.token,
        },
      })
      .then(function (response) {

        setLoading(false);
        if (response.data.status === "SUCCESS") {
          props.handleBegin();
        } else {
        }
      })
      .catch(function (error) {
        setLoading(false);
      });
  };

  const renderInstruction = (text) => {
    let str = text?.replaceAll("\r\n", "<br/>") || "";
    return str;
  };

  return (
    <div className="w-full px-0 flex justify-center items-center">
      <div className="rounded-lg w-full md:h-max flex flex-col justify-between items-start px-5 md:w-2/3 bg-[#ffffffd9] border-[4px] py-2 md:py-4">
        <div className="flex flex-col justify-center items-center w-full">
          <LogoApp />
          <div className="w-full">
            <div className="mb-2 text-xl text-center font-bold text-black">
              Welcome
            </div>
            <div className="mb-2 text-4xl text-center font-bold text-black flex flex-col md:flex-row w-full justify-center items-center">
              <span>
                {user?.name}
              </span>

            </div>

            <div className="w-full border border-gray-400 p-2 rounded-md">
              <div className="mt-2 text-xl font-bold text-black text-left">
                Instructions:
              </div>
              <div className="font-semibold mt-2 text-left">
                {parse(renderInstruction(game?.instruction || "") || "")}
              </div>
              <div className="uppercase bg-yellow-300 py-2  font-bold text-red-600 text-xs mt-2">
                {props?.config?.warning}
              </div>
            </div>
          </div>
          <div className="flex mt-4 justify-between w-full space-x-2">
            <button
              onClick={() => {
                if (loading) {
                  return;
                }

                props.onBack();
              }}
              type="button"
              className=" flex-none w-24 font-bold cursor-pointer flex justify-center items-center text-base text-white h-[45px] px-2 border-b-4 border-red-700 bg-red-500 rounded-lg "
            >
              BACK
            </button>
            <button
              onClick={() => postScore()}
              className="font-bold cursor-pointer max-w-max flex justify-center items-center text-base text-white h-[45px] px-10 border-b-4 border-blue-700 bg-blue-500 rounded-lg "
            >
              {loading ? "Loading..." : "BEGIN"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardIntro;
